import YouTubeIcon from '@mui/icons-material/YouTube';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconYouTubeComponent = ({ color = petrol.main, ...rest }) => {
  return <YouTubeIcon sx={{ color: color }} {...rest} />;
};

IconYouTubeComponent.displayName = 'IconYouTube';

const IconYouTube = memo(IconYouTubeComponent);
export default IconYouTube;
